module.exports = __webpack_public_path__ + "static/media/7 Angel In A Blue Dress.9e94094e.mp3";